import * as DeliveryCommon from "../../utils/delivery-transforms.common";
import * as SharedTransform from "../../mocks/SharedTransform/response.transforms";
import { getTimeSlotPayload } from "../../mocks/SharedTransform/response.transforms";

// Re-export common interfaces from the common utility
export type {
  MetaData,
  Name,
  Product,
  Address,
  ContactInfo,
  PosInformation,
  DeliverySlot,
  CustomerContactInfo,
  DeliveryInformation,
  PickUpContactInfo,
  PickupSlot,
  PickUpInformation,
  Reason,
  Order,
  CountryDetails,
  AssignedStatus,
  Vehicle,
  Driver,
  Route,
  Sort,
  Pageable,
  Sort2,
  Statuses,
} from "../../utils/delivery-transforms.common";

// Re-export common utility functions
export const getFilterAttributeValue = SharedTransform.getFilterAttributeValue;
export const getAddressInfo = DeliveryCommon.getAddressInfo;
export const getLatLong = DeliveryCommon.getLatLong;
export const createPublishRoutesPayload =
  DeliveryCommon.createPublishRoutesPayload;
export const createDeleteRoutePayload = DeliveryCommon.createDeleteRoutePayload;
export const createUpdateOrderStatusPayload =
  DeliveryCommon.createUpdateOrderStatusPayload;
export const getDiscardRoutePayload = DeliveryCommon.getDiscardRoutePayload;
export const createPayloadForUpdatingCustAddress =
  DeliveryCommon.createPayloadForUpdatingCustAddress;
export const getPlannedRoutesData = (routeData: any) =>
  DeliveryCommon.getPlannedRoutesData(routeData, false);
export const transformRouteConsignments =
  DeliveryCommon.transformRouteConsignments;
export const getAllAreasAndSlots = DeliveryCommon.getAllAreasAndSlots;
export const getDropdownsData = DeliveryCommon.getDropdownsData;
export const checkTerminalStatus = DeliveryCommon.checkTerminalStatus;
export const getConsignmentStatusField = DeliveryCommon.getConsignmentStatusField
export const getRouteStatusField = DeliveryCommon.getRouteStatusField;
export const lastMileVTOrdersDataTransform = DeliveryCommon.CarrefourOrdersDataTransform
export const lastMileVTRoutesDataTransform = DeliveryCommon.DeliveryRoutesDataTransform

export const createFilterPayload = (
  payload: any,
  data?: any,
  isLoadMore?: boolean,
  isRoute?: boolean
) => {
  const basePayload = DeliveryCommon.createBaseFilterPayload(
    payload,
    data,
    isLoadMore
  );

  if (payload.deliveryProposition) {
    basePayload.attributes.push({
      key: payload.deliveryProposition.fieldName,
      value: ["SVT"],
    });
    delete basePayload.deliveryProposition;
  }

  basePayload.isSVT = true;
  return basePayload;
};

export const createPayloadForExcelExport = (
  payload: any,
  data?: any,
  isLoadMore?: boolean,
  isRoute?: boolean
) => {
  const newPayload = createFilterPayload(payload, data, isLoadMore, isRoute);
  const orderFilterRequestDto = { orderFilterRequestDto: newPayload };
  return orderFilterRequestDto;
};

export const createRoutesPayloadForExcelExport = (
  payload: any,
  data?: any,
  isLoadMore?: boolean,
  isRoute?: boolean
) => {
  const newPayload = createFilterPayload(payload, data, isLoadMore, isRoute);
  const routeFilterRequestDto = { routeFilterRequestDto: newPayload };
  return routeFilterRequestDto;
};

export const createGetAllPlannedRoutesPayload = (params: any) => {
  const basePayload = getTimeSlotPayload(params);
  return {
    ...basePayload,
    isSVT: true,
  };
};

